module.exports = __webpack_public_path__ + "static/img/product3s-1.4c4c295.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3s-1.jpg
// module id = ZUSO
// module chunks = 0